/**
 * Extends AbstractDownloadDialog to display the Ids of selected sites.
 */

import AbstractDownloadDialog from './abstract-download-dialog';
export default class DownloadListDialogComponent extends AbstractDownloadDialog {

  buildHtml(options) {
    let html = '';
    const _siteSelections = options.selectedSitesModel.getData();
    Object.keys(_siteSelections).forEach((_id) => {
      const _site = _siteSelections[_id];
      html += _id + '\n';
    });
    return html;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/download-list-dialog.js